import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';
import { ErrorBanner } from '@/components/ui';
import { templatesService, type SearchTemplate } from '@/api/services/templates';
import { useMe } from '@/context/MeContext';
import { canFavoriteTemplates } from '@/utils/navCapabilities';
import { formatApiError } from '@/utils/formatApiError';

export default function TemplateFavoritesPage() {
  const { me } = useMe();
  const canFavorite = canFavoriteTemplates(me);
  const [items, setItems] = useState<SearchTemplate[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!canFavorite) {
      setLoading(false);
      return;
    }
    templatesService
      .favorites()
      .then((r) => setItems(r.items))
      .catch((e) => setError(formatApiError(e, 'Failed to load favorites')))
      .finally(() => setLoading(false));
  }, [canFavorite]);

  if (!canFavorite) {
    return (
      <>
        <PageHeader title="Favorite templates" subtitle="Templates you saved for later">
          <Link to="/templates" className="btn btn-ghost btn-sm">
            Marketplace
          </Link>
        </PageHeader>
        <p className="muted">You do not have permission to manage template favorites.</p>
      </>
    );
  }

  return (
    <>
      <PageHeader title="Favorite templates" subtitle="Templates you saved for later">
        <Link to="/templates" className="btn btn-ghost btn-sm">
          Marketplace
        </Link>
      </PageHeader>
      {error ? <ErrorBanner message={error} /> : null}
      {loading ? <p className="muted">Loading…</p> : null}
      {!loading && items.length === 0 ? <p className="muted">No favorites yet.</p> : null}
      <div className="template-grid">
        {items.map((t) => (
          <article key={t.id} className="card card-elevated template-card">
            <h3>{t.title}</h3>
            <p className="muted">{t.shortDescription}</p>
            <Link to={`/templates/${t.id}`} className="btn btn-sm">
              Open
            </Link>
          </article>
        ))}
      </div>
    </>
  );
}
